import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../../app/_services/auth.service';
import { StoragePeriodTypeConstants } from '../constants/StoragePeriodTypeConstants';
import { ErrorHandlerService } from '../custom/services/error-handler.service';
import { Growl } from '../custom/services/growl.service';
import { SsoSettingsResource } from '../resources/sso-settings.resource';

@Component({
    selector: 'pkp-storage-admin-prisma-credit-limit-check-form',
    template: require('./storage-admin-prisma-credit-limit-check-form.component.html')
})
export class StorageAdminPrismaCreditLimitCheckFormComponent implements OnInit {
    @Input('framework') newFramework: Partial<
        StorageFrameworkDto & StorageFrameworkCreationDto
    >;
    @Output() onFrameworkCreated = new EventEmitter<StorageFrameworkDto>();
    @Output() onCancel = new EventEmitter<void>();

    authUser: LoginResult;
    storagePeriodTypes: {
        value: StoragePeriodType;
        [label: string]: string;
    }[] = StoragePeriodTypeConstants.asLabelValueArray();
    submitting: boolean = false;

    constructor(
        private ssoSettingsResource: SsoSettingsResource,
        private authService: AuthService,
        private errorHandlerService: ErrorHandlerService,
        private growl: Growl
    ) {}

    ngOnInit(): void {
        this.authService.userLoginPromise.promise.then(
            (res) => (this.authUser = res)
        );

        if (this.newFramework == null) this.initNewCreditFramework();
        else this.newFramework = JSON.parse(JSON.stringify(this.newFramework));
    }

    initNewCreditFramework() {
        this.newFramework = { creditFactors: [], identifier: null };
    }

    removeCreditFactor(index: number) {
        this.newFramework.creditFactors.splice(index, 1);
    }

    initNewProductPeriod() {
        this.newFramework.creditFactors.push({
            value: {}
        } as StorageFrameworkCreditFactorDto);
    }

    submitNewFramework() {
        const allPeriodTypes = this.newFramework.creditFactors.map(
            (cF) => cF.periodType
        );
        const distinctPeriodTypes = allPeriodTypes.reduce((prev, curr) => {
            if (prev.indexOf(curr) === -1) prev.push(curr);
            return prev;
        }, []);

        if (allPeriodTypes.length > distinctPeriodTypes.length) {
            this.growl.show(
                'You must not specify multiple credit factors for the same period.',
                'danger'
            );
            return;
        }

        this.submitting = true;

        if ((this.newFramework as StorageFrameworkDto).id == null) {
            this.ssoSettingsResource
                .saveCreditFramework(
                    this.authUser.referenceId,
                    this.newFramework as StorageFrameworkCreationDto
                )
                .pipe(finalize(() => (this.submitting = false)))
                .subscribe((res) => {
                    this.growl.show(
                        'Successfully saved credit framework',
                        'success'
                    );
                    this.initNewCreditFramework();
                    this.onFrameworkCreated.emit(res);
                }, this.errorHandlerService.handle.bind(this));
        } else {
            this.ssoSettingsResource
                .updateCreditFramework(
                    this.authUser.referenceId,
                    this.newFramework as StorageFrameworkDto
                )
                .pipe(finalize(() => (this.submitting = false)))
                .subscribe((res) => {
                    this.growl.show(
                        'Successfully updated credit framework',
                        'success'
                    );
                    this.onFrameworkCreated.emit(res);
                }, this.errorHandlerService.handle.bind(this));
        }
    }
}
